document.addEventListener('DOMContentLoaded', () => {
  const path = window.location.pathname;
  const query = window.location.search;

  // Solo continuar si:
  // 1. Es una colección real
  // 2. No hay búsqueda activa
  if (!path.startsWith('/collections/') || query.includes('q=')) return;

  const observer = new MutationObserver(() => {
    const productos = document.querySelectorAll('li.grid__item');
    const yaExiste = document.querySelector('.pronto-mas-banner');

    if (productos.length > 0 && productos.length < 5 && !yaExiste) {
      const banner = document.createElement('div');
      banner.className = 'pronto-mas-banner';
      banner.innerHTML = '✨ ¡Pronto más productos en esta colección! ✨';
      productos[productos.length - 1].parentElement.appendChild(banner);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

